/**
 * v-visible：类 v-show，并支持自定义修饰符
 * ------------------------------------------------------------
 * 用法与 v-show 一致，通过修饰符切换“隐藏方式”。
 *
 * @example
 * // 等同 v-show，用 display 切换
 * <div v-visible="isActive">...</div>
 *
 * @example
 * // 修饰符 .offscreen：false 时移出屏幕（不改变 display），实现预加载
 * <div v-visible.offscreen="isActive">
 *   <pdf-preview :url="url" />
 * </div>
 *
 * @param {boolean} value   true = 显示，false = 隐藏（行为由修饰符决定）
 * @modifier offscreen      false 时移出视口而非 display:none，便于预渲染/预加载
 * ------------------------------------------------------------
 */

const OFFSCREEN_STYLES = {
  position: 'fixed',
  left: '-9999px',
  top: '0',
  visibility: 'hidden',
  pointerEvents: 'none',
  zIndex: '-1'
};

function applyOffscreen(el) {
  Object.assign(el.style, OFFSCREEN_STYLES);
}

function restoreOffscreenStyles(el) {
  ['position', 'left', 'top', 'visibility', 'pointer-events', 'z-index'].forEach((prop) =>
    el.style.removeProperty(prop)
  );
}

function update(el, value, useOffscreen) {
  if (value) {
    if (useOffscreen) {
      restoreOffscreenStyles(el);
    } else {
      el.style.display = '';
    }
  } else {
    if (useOffscreen) {
      applyOffscreen(el);
    } else {
      el.style.display = 'none';
    }
  }
}

export default {
  mounted(el, binding) {
    const useOffscreen = binding.modifiers.offscreen === true;
    update(el, binding.value, useOffscreen);
  },
  updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    const useOffscreen = binding.modifiers.offscreen === true;
    update(el, binding.value, useOffscreen);
  },
  unmounted(el, binding) {
    if (binding.modifiers.offscreen) {
      restoreOffscreenStyles(el);
    } else {
      el.style.display = '';
    }
  }
};
